/**
 * Return a string name for a resource that automatically prepends the
 * provided namespace to avoid cross-namespace name conflicts
 * @param {*} namespace
 * @param {*} resource
 * @returns
 */
export function getNamespacedResource(namespace, resource) {
    return `${namespace}/${resource}`;
}

/**
 * Check if a module with the specified namespace is registered in the provided
 * rootState. Generally that will be this.$store.state
 * @param {*} namespace
 * @param {*} rootState
 * @returns
 */
export function isModuleRegistered(namespace, rootState) {
    return rootState[namespace] != null;
}
